import {
  useController,
  useFieldArray,
  useForm,
  useWatch,
  useFormState,
} from 'react-hook-form';

export const useFormController = (props) => useForm(props);
export const useFieldArrayController = (props) => useFieldArray(props);
export const useFormWatch = (props) => useWatch(props);
export const useFieldController = (props) => useController(props);
export const useFormControllerState = (props) => useFormState(props);
